import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('review');
const GET_REVIEWS = define('GET_REVIEWS', true);
const GET_REVIEW = define('GET_REVIEW', true);
const SET_CHANGE_REVIEW = define('SET_CHANGE_REVIEW', true);
const GET_SKIP_REVIEWS = define('GET_SKIP_REVIEWS', true);
const DELETE_REVIEW = define('DELETE_REVIEW', true);
const ADD_REVIEW = define('ADD_REVIEW', true);

const initialState = {
  reviews: [],
  review: {},
  isLoading: true,
  processing: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_REVIEWS.PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case GET_REVIEWS.RESOLVED:
      return {
        ...state,
        reviews: action.data,
        isLoading: false,
      };
    case GET_REVIEW.PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case GET_REVIEW.RESOLVED:
      return {
        ...state,
        review: action.data,
        isLoading: false,
      };
    case SET_CHANGE_REVIEW.PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case SET_CHANGE_REVIEW.RESOLVED:
      return {
        ...state,
        isLoading: false,
      };
    case GET_SKIP_REVIEWS.PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case GET_SKIP_REVIEWS.RESOLVED:
      return {
        ...state,
        reviews: action.data,
        isLoading: false,
      };
    case DELETE_REVIEW.PENDING:
    case ADD_REVIEW.PENDING:
      return {
        ...state,
        processing: true
      };
    case DELETE_REVIEW.RESOLVED:
    case ADD_REVIEW.RESOLVED:
      return {
        ...state,
        processing: false
      };
    default:
      return state;
  }
}

export const actions = {
  getReviews: () => ({
    type: GET_REVIEWS,
    promise: api.get('/reviews'),
    error: 'Unable to load reviews'
  }),
  getReview: (id) => ({
    type: GET_REVIEW,
    promise: api.get(`/reviews/${id}/view`),
    error: 'Unable to load review'
  }),
  getSkipReviews: (skip = 0) => ({
    type: GET_SKIP_REVIEWS,
    promise: api.get(`/reviews?skip=${skip}`)
  }),
  setChangeReview: ({ id, lxId }) => ({
    type: SET_CHANGE_REVIEW,
    promise: api.post(`/reviews/${id}/change-review`, { lx_id: lxId }),
    error: 'Something went wrong'
  }),
  deleteReview: (id) => ({
    type: DELETE_REVIEW,
    promise: api.delete(`/reviews/${id}`),
    success: 'Review has been deleted',
    error: 'Unable to delete review'
  }),
  addReview: (review, shouldSendEmailToLocalExpert) => ({
    type: ADD_REVIEW,
    promise: api.post('/reviews', { review, shouldSendEmailToLocalExpert }),
    success: 'Review has been added',
    error: 'Unable to add review',
  }),
};



// WEBPACK FOOTER //
// ./src/ducks/review.js